<template>
		<div id="pg2">  
			<section class="publicar">
				<img v-responsive.xl.lg src="@/assets/landing/empleador/publicar/publicar1680x1050.jpg"
					 class="section_img">
				<img v-responsive.md src="@/assets/landing/empleador/publicar/publicar1024x768.jpg"
					 class="section_img">
				<img v-responsive.xs.sm src="@/assets/landing/empleador/publicar/publicar768x1024.jpg"
					 class="section_img">
				<div class="hyper-link"> 
					<div :class="isMobile ? 'row justify-content-center' : ''" >
						<a href="/perfil/empleos" :class="isMobile ? 'btn b-orange w-50 float-center' :  'btn b-orange w-30 float-right'" v-if="isLogin">
							¡Comienza Ahora!
						</a>
						<a href="/registrar/empresa" :class="isMobile ? 'btn b-orange w-50 float-center' :  'btn b-orange w-30 float-right'" v-else>
							¡Comienza Ahora!
						</a> 
					</div>
				</div>
			</section>
		</div>
</template>

<script>
export default {
	name: "empleador",
	props:['isLogin'], 
}
</script>

<style scoped lang="scss">
.section_img {
	width: 100%;
	z-index: 1;
}
.publicar{
	position:relative;
}
.publicar .hyper-link a{
	font-size: large;
}
.publicar .hyper-link{
	position: absolute;
	bottom: 15%;
	right: 21%;

	// @media only screen and (max-width: 450px) {
	// 	bottom: 52%;
	// 	width: 80%; 
	// }

	@media only screen and (min-width: 320px)  and (max-device-width: 581px)  {
		top:  74.5%;
		left: -4vw;
		width: 90%;
	}
	@media only screen and (min-width: 768px) {
		bottom: 25%;
		right: 10%;
		width: 45%;
	}
	@media only screen and (min-width: 960px) {
		bottom: 25%;
		right: 8%;
	}
	@media only screen and (min-width: 1440px) {
		bottom: 25%;
		right: 16%;
		width: 25%;
	}
	@media only screen and (min-width: 2000px) {
		bottom: 15%;
		right: 21%;
	}
	@media only screen and (max-device-width: 480px) {
		bottom: 4%;
		right: 3%;
	}
	@media only screen and (device-width: 768px) {
		bottom: 15%;
		right: 21%;
	}
	// /* different techniques for iPad screening */
	// @media only screen and (min-device-width: 481px) and (max-device-width: 1024px) and (orientation: portrait) {
	// 	bottom: 8%;
	// 	right: 11%;
	// }

	// @media only screen and (min-device-width: 481px) and (max-device-width: 1024px) and (orientation: landscape) {
	// 	/* For landscape layouts only */
	// 	bottom: 15%;
	// 	right: 21%;
	// }
}


/**
  hyper-link:
 */
//.hyper-link {
//	position: absolute;
//	z-index: 2;
//	width: 100%;
//	right: 0;
//	height:50px;
//	margin:0 auto;
//	background-color:red;

	//@media only screen and (min-width: 480px) {
	//	margin-top: 108%;
	//}
	//@media only screen and (min-width: 768px) {
	//	margin-top: 57%;
	//}
	//@media only screen and (min-width: 960px) {
	//	margin-top: 50%
	//}
	//@media only screen and (min-width: 1440px) {
	//	margin-top:46.5%;
	//}
	//@media only screen and (min-width: 2000px) {
	//	margin-top: 32%;
	//}
	//@media only screen and (max-device-width: 480px) {
	//	margin-top: 75%;
	//}
	//@media only screen and (device-width: 768px) {
	//	margin-top: 44%;
	//}
	///* different techniques for iPad screening */
	//@media only screen and (min-device-width: 481px) and (max-device-width: 1024px) and (orientation: portrait) {
	//	margin-top: 83%;
	//}
	//
	//@media only screen and (min-device-width: 481px) and (max-device-width: 1024px) and (orientation: landscape) {
	//	/* For landscape layouts only */
	//	margin-top: 41%;
	//}
//}
</style>



// WEBPACK FOOTER //
// src/views/landing/empleador/publicar.vue